export const sendUXSEvent = (name: string) => {
  if (typeof window !== 'undefined' && window.UXS) {
    window.UXS.sendEvent(name);
  }
};
